import { Card, Text, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  card: {
    minWidth: '200px',
    padding: tokens.spacingVerticalL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    color: tokens.colorNeutralForeground3,
  },
  icon: {
    fontSize: '18px',
    display: 'inline-flex',
  },
  value: {
    fontSize: tokens.fontSizeHero700,
    lineHeight: tokens.lineHeightHero700,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  caption: {
    color: tokens.colorNeutralForeground3,
  },
});

export interface TileProps {
  /** KPI label, e.g. "Tenants". */
  label: string;
  /** Primary value (already formatted). */
  value: ReactNode;
  /** Optional leading icon. */
  icon?: ReactNode;
  /** Optional sub-caption, e.g. a status word. */
  caption?: ReactNode;
}

/** Azure-portal dashboard KPI tile built on a Fluent {@link Card}. */
export function Tile({ label, value, icon, caption }: TileProps): JSX.Element {
  const styles = useStyles();

  return (
    <Card className={styles.card} appearance="filled-alternative">
      <div className={styles.header}>
        {icon !== undefined && <span className={styles.icon}>{icon}</span>}
        <Text>{label}</Text>
      </div>
      <span className={styles.value}>{value}</span>
      {caption !== undefined && (
        <Text className={styles.caption} size={200}>
          {caption}
        </Text>
      )}
    </Card>
  );
}
